module.exports = __webpack_public_path__ + "img/dt.ca349574.jpg";